import type { StructuredError } from './l3-types';

export type L3Report = {
  schemaVersion: 1;
  runId: string;
  lot: 'L3';
  environment: {
    commit: string;
    treeState: string;
    origin: string;
    userAgent: string;
    executedAt: string;
  };
  fixtures: Array<{ id: string; kind: 'visual' | 'audio' | 'invalid'; status: 'CONFORMANT' | 'NON_CONFORMANT'; detail: string }>;
  measurements: {
    decodedFrames: number;
    renderedFrames: number;
    pcmSamplesPerChannel: number;
  };
  cleanup: { openImageHandles: number; rendererDisposed: boolean };
  errors: StructuredError[];
  status: 'CONFORMANT' | 'NON_CONFORMANT';
};

export function createL3Report(): L3Report {
  return {
    schemaVersion: 1,
    runId: `l3-${new Date().toISOString().replaceAll(/[:.]/g, '-')}-${crypto.randomUUID()}`,
    lot: 'L3',
    environment: {
      commit: __BITPOP_COMMIT__,
      treeState: __BITPOP_TREE_STATE__,
      origin: window.location.origin,
      userAgent: navigator.userAgent,
      executedAt: new Date().toISOString(),
    },
    fixtures: [],
    measurements: { decodedFrames: 0, renderedFrames: 0, pcmSamplesPerChannel: 0 },
    cleanup: { openImageHandles: 0, rendererDisposed: false },
    errors: [],
    status: 'NON_CONFORMANT',
  };
}
